import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes, {TagActionTypes} from "../constants/action_types";
import {IssueOverrideTagId} from "common/types/issue_override_tag";

export type RemoveIssueOverrideTagAction = {
  type: TagActionTypes["ISSUE_OVERRIDE_TAG_REMOVE"]["SUCCESS"];
  payload: {id: IssueOverrideTagId};
};

export default function issueOverrideTagRemove(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_OVERRIDE_TAG_REMOVE,
    (organisationId, issueOverrideTagId) =>
      requestor
        .delete(
          `${basePath}/organisation/${organisationId}/issue_override_tag/${issueOverrideTagId}`,
          {
            withCredentials: true,
          },
        )
        .then(response => response.data),
  );
}
